import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import debounce from 'lodash.debounce';

import { PageTitle } from '../ui';
import { TabList } from '../ui/TabList';
import { LeftArrow } from '../../icons';
import CarMobileViewTitle from './carMobileViewTitle';
import usePersonStore from '../../store/personStore';
import { PAGES } from '../../config/constants';

export const Header = ({
  activeTab,
  searchTerm,
  children,
  handleActiveTab,
  handleCarSearch,
  selectedCar,
  handleAssignDriver,
}) => {
  const navigate = useNavigate();
  const debouncedHandleSearch = debounce(handleCarSearch, 300);
  const pageAccess = usePersonStore((store) => store.pageAccess);
  const [searchInput, setSearchInput] = useState('');

  const { TRACK_YOUR_CAR } = PAGES;

  return (
    <div className="flex flex-col gap-5">
      <PageTitle
        title={
          <div className="flex max-lg:gap-x-2 items-center max-lg:justify-between max-lg:order-1">
            <button className='lg:p-2' type="button" onClick={() => navigate('/dashboard')}>
              <LeftArrow width={24} height={24} />
            </button>
            <h2>My Cars</h2>

            <CarMobileViewTitle
              selectedCar={selectedCar}
              handleAssignClick={handleAssignDriver}
            />
          </div>
        }
        endComponent={
          pageAccess.includes(TRACK_YOUR_CAR) ? (
            <TabList
              className="rounded-md max-lg:w-full max-lg:items-center max-lg:justify-center"
              wrapperClassName="max-lg:self-center max-lg:w-full"
              tabs={['Μισθώσεις', 'Εκκρεμείς Παραγγελίες']}
              active={activeTab}
              setActive={(value) => {
                setSearchInput('');
                handleActiveTab(value);
              }}
            />
          ) : (
            <></>
          )
        }
        searchClassName="max-lg:order-3"
        searchTerm={searchTerm}
        searchInput={searchInput}
        handleSearch={(value) => {
          setSearchInput(value);
          debouncedHandleSearch(value.trim());
          /*  if (activeTab) {
            handleLeasedCarSearch(value);
          } else {
            handleCarSearch(value);
          } */
        }}
      />
      {children}
    </div>
  );
};

export default Header;
